import React from 'react';

const Button = ({
    children,
    onClick,
    variant = 'primary',
    size = 'md',
    disabled = false,
    className = '',
    style
}) => {
    const variants = {
        primary: 'tw-bg-button-1 tw-text-global-6 hover:tw-opacity-90',
        secondary: 'tw-bg-button-2 tw-text-global-6 hover:tw-opacity-90',
        tertiary: 'tw-bg-button-3 tw-text-button-1 hover:tw-opacity-90'
    };

    const sizes = {
        sm: 'tw-px-3 tw-py-1 tw-text-sm',
        md: 'tw-px-4 tw-py-2',
        lg: 'tw-px-5 tw-py-3 tw-text-lg'
    };

    return (
        <button
            style={style}
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            className={`tw-rounded-lg tw-font-inter tw-font-semibold tw-transition-opacity ${variants[variant]} ${sizes[size]} ${disabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''} ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;
